// 로그인 전에 가려던 앱 내부 경로를 GitHub 왕복 너머로 나른다. OAuth state 와 같은
// sessionStorage 수단을 쓴다(같은 origin·같은 탭이라 리다이렉트를 건너 유지된다).
const authReturnToStorageKey = "spawning-pool:auth:return-to";

// 로그인 뒤 돌아갈 곳이 없을 때의 기본 목적지 — `/` 의 로그인 후 착지와 같은 곳이어야 한다.
export const defaultSignedInPath = "/datasets";

export function saveAuthReturnTo(path: string): void {
  const safePath = normalizeInternalPath(path);
  if (safePath === null) {
    clearAuthReturnTo();
    return;
  }

  try {
    window.sessionStorage.setItem(authReturnToStorageKey, safePath);
  } catch {
    // 저장에 실패하면 기본 목적지로 간다. 로그인 자체를 막지는 않는다.
  }
}

export function consumeAuthReturnTo(): string | null {
  let stored: string | null;
  try {
    stored = window.sessionStorage.getItem(authReturnToStorageKey);
    window.sessionStorage.removeItem(authReturnToStorageKey);
  } catch {
    return null;
  }

  if (stored === null) {
    return null;
  }

  // 저장 시점에 검증했더라도 저장소 값은 외부 입력으로 취급한다.
  return normalizeInternalPath(stored);
}

export function clearAuthReturnTo(): void {
  try {
    window.sessionStorage.removeItem(authReturnToStorageKey);
  } catch {
    // 저장소가 막힌 환경에서는 지울 값도 없다.
  }
}

// 앱 내부 경로만 통과시킨다 — 절대 URL(`https://evil`)과 protocol-relative(`//evil`)를
// 막아 로그인 뒤 외부로 튕기는 open redirect 를 만들지 않는다.
function normalizeInternalPath(raw: string): string | null {
  const path = raw.trim();
  if (!path.startsWith("/") || path.startsWith("//")) {
    return null;
  }

  // 랜딩·콜백으로 되돌아가면 로그인 직후 다시 로그인 화면이 된다.
  if (path === "/" || path.startsWith("/auth/")) {
    return null;
  }

  return path;
}
